import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-complete-resume-propmpt',
  templateUrl: './complete-resume-propmpt.component.html',
  styleUrls: ['./complete-resume-propmpt.component.scss']
})
export class CompleteResumePropmptComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
